// extracted by mini-css-extract-plugin
module.exports = {"card":"Swimlane_card__3N-fe","header":"Swimlane_header__2dzgN"};